import { WebPlugin } from '@capacitor/core';
export class GetAppInfoWeb extends WebPlugin {
    constructor() {
        super({
            name: 'GetAppInfo',
            platforms: ['web'],
        });
    }
    getAvailableApps() {
        throw new Error('Method not implemented.');
    }
    getAppIcon(options) {
        throw new Error(`Method not implemented. ${options}`);
    }
    getAppLabel(options) {
        throw new Error(`Method not implemented. ${options}`);
    }
    launchApp(options) {
        throw new Error(`Method not implemented. ${options}`);
    }
    canLaunchApp(options) {
        throw new Error(`Method not implemented. ${options}`);
    }
}
//# sourceMappingURL=web.js.map